/**
 * safeStringify — JSON.stringify an toàn cho logging/breadcrumb (Sprint 27 D5 #17).
 *
 * Vá triệt để hot-fix Sprint 26 D5 (main.tsx) vốn chỉ xử undefined:
 * - JSON.stringify(undefined) trả undefined (literal) → `.slice()` crash → dùng "??".
 * - Nhưng JSON.stringify vẫn THROW với circular reference / BigInt → "??" không đỡ.
 *
 * Hàm này try/catch trọn vẹn + fallback String(value) + truncate.
 */
export function safeStringify(value: unknown, maxLen = 500): string {
  let out: string;
  try {
    out = JSON.stringify(value) ?? "undefined";
  } catch {
    // Circular ref, BigInt, getter throw... → fallback an toàn.
    try {
      out = String(value);
    } catch {
      out = "[unstringifiable]";
    }
  }
  return out.slice(0, maxLen);
}
